import React from 'react';
import { IoIosArrowBack } from 'react-icons/io';
import { Link } from 'react-router-dom';

import { Container, Content, Button } from './styles';

interface BackButtonProps {
  to: string;
}

const BackButton: React.FC<BackButtonProps> = ({ to }) => (
  <Container>
    <Content>
      <Link to={to}>
        <Button>
          <IoIosArrowBack style={{ width: '14px', height: 'auto' }} />
          Voltar
        </Button>
      </Link>
    </Content>
  </Container>
);

export default BackButton;
